import axios from 'axios';
import { generatePath } from 'react-router';
import type { ILanguage, IProduct, ISettingsKeystoreEntry } from '../../domain';
import { ApiBaseService } from '../api-base-service';

export const initialHeaderUrl = process.env.NODE_ENV === 'development' ? '/' : '/portal/';

export enum CustomizationEndpoint {
    IMAGES = '/images/:id?',
    LANGUAGES = '/languages',
    PRODUCTS = '/products',
    SETTINGS_STORE = '/settings-store/:path?',
}

export const SettingsBaseUrl = '/delegate/customization/v3';

export class SettingsApiService extends ApiBaseService {
    constructor(context = SettingsBaseUrl) {
        super(context);
    }

    async getContextHeaders(): Promise<{}> {
        const { headers } = await axios.head<string>(initialHeaderUrl);

        return headers;
    }

    async getKeystoreEntries(): Promise<ISettingsKeystoreEntry[]> {
        const { data } = await this.http.get<ISettingsKeystoreEntry[]>(generatePath(CustomizationEndpoint.SETTINGS_STORE));

        return data;
    }

    async getLanguages(): Promise<ILanguage[]> {
        const { data } = await this.http.get<ILanguage[]>(CustomizationEndpoint.LANGUAGES);

        return data;
    }

    async getProducts(categoryIds: string[]): Promise<IProduct[]> {
        const { data } = await this.http.get<IProduct[]>(CustomizationEndpoint.PRODUCTS, { params: { categories: categoryIds?.join(',') } });

        return data;
    }
}

export const getImageUrl = (id: string): string => SettingsBaseUrl + generatePath(CustomizationEndpoint.IMAGES, { id });
